import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Meta } from '@angular/platform-browser';
import { AuthStorageService, BaseSiteService, UserIdService } from '@spartacus/core';
import { Observable, throwError } from 'rxjs';
import { catchError, retry, take } from 'rxjs/operators';
import { ASM_ENABLED_LOCAL_STORAGE_KEY } from 'src/app/spartacus/features/asm/asm-constant';
import { environment } from 'src/environments/environment';
import { StorageService } from '../storage/storage.service';

export interface CookieConsentPayload {
  userId: string;
}

@Injectable({
  providedIn: 'root',
})
export class CookieConsentService {
  baseSite$: Observable<string> = this.baseService.getActive();
  occUrl = this.meta.getTag('name=occ-backend-base-url');
  url = `${this.occUrl.content}${environment.prefix}${this.baseSiteId}`;
  headers = new HttpHeaders().set('Content-Type', 'application/json');
  userCurrent$: Observable<string> = this.userIdService.getUserId();
  asmEnabled = this.storageService.getLocalStorageItem(ASM_ENABLED_LOCAL_STORAGE_KEY);
  constructor(
    private meta: Meta,
    protected http: HttpClient,
    protected authStorageService: AuthStorageService,
    protected userIdService: UserIdService,
    protected baseService: BaseSiteService,
    private storageService: StorageService
  ) {}
  get baseSiteId(): string {
    let baseSiteId: string;
    this.baseSite$.pipe(take(1)).subscribe((baseSiteData) => (baseSiteId = baseSiteData));
    return baseSiteId;
  }
  get userCurrent(): string {
    let userCurrent: string;
    this.userCurrent$.pipe(take(1)).subscribe((userId) => (userCurrent = userId));
    return userCurrent;
  }
  get tokenId(): string {
    let tokenId: string;
    this.authStorageService
      .getToken()
      .pipe(take(1))
      .subscribe((tokenIdData) => (tokenId = tokenIdData.access_token));
    return tokenId;
  }
  submitCookieConsent(payload: CookieConsentPayload): Observable<any> {
    let userUidCookie;
    if (this.asmEnabled && this.userCurrent === 'anonymous') {
      const asmUserId = this.storageService.getLocalStorageItem('asmUserId');
      userUidCookie = asmUserId;
    } else {
      userUidCookie = this.userCurrent;
    }
    return this.http
      .put(
        // tslint:disable-next-line: max-line-length
        `${this.url}/users/${userUidCookie}/cookieConsent`,
        {
          headers: this.headers,
        }
      )
      .pipe(retry(1), catchError(this.errorHandl)); //tslint:disable-line
  }

  // Error handling
  errorHandl(error: any) {
    let errorMessage = '';
    if (error.error instanceof ErrorEvent) {
      // Get client-side error
      errorMessage = error.error.message;
    } else {
      // Get server-side error
      errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
    }
    return throwError(errorMessage);
  }
}
